<template>
  <v-container>
    <v-row>
      <v-col
        v-for="(vessel, idx) in vessels" :key="idx"
        class="pa-0 mb-2"
        cols=12
        >
      <v-card
        :elevation="0"
        outlined
        tile
        >
        <v-card-title>
          {{ $t('related_vessel') }} {{ idx + 1 }}
          <v-spacer></v-spacer>
            <v-btn
              icon
              x-small
              @click="remove(idx)"
              >
              <v-icon
                class="mdi mdi-close"
                >
              </v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
          <v-radio-group
            v-model="vessel.type"
            row
          >
            <v-radio v-for="option in typeOptions" :key='option.value'
              :label="$t(option.text)"
              :value="option.value"
            />
          </v-radio-group>
          <vessel-details ref="relatedVesselDetails" v-if="vessel.type === 'vessel'"></vessel-details>
          <aeroplane-details ref="relatedAeroplaneDetails" v-if="vessel.type === 'aeroplane'"></aeroplane-details>
        </v-card-text>
      </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-btn
        small
        :block="$vuetify.breakpoint.smAndDown"
        plain
        raised
        tile
        elevation="0"
        @click="addMore"
      >
        {{ $t('add_related_vessel') }}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import VesselDetails from './VesselDetails'
import AeroplaneDetails from './AeroplaneDetails.vue'
import { maocData } from '../../services/MaocData'

export default {
  name: 'RelatedVessels',
  data: vm => ({
    typeOptions: maocData.asLocalizedSelect('vesselTypes').slice(0, 2),
    vessels: [{ type: '' }]
  }),
  components: {
    VesselDetails,
    AeroplaneDetails
  },
  methods: {
    addMore () {
      this.vessels.push({ type: '' })
    },
    remove (idx) {
      this.vessels.splice(idx, 1)
    },
    getData: function () {
      var data = []
      var myRefs = this.$refs

      var vesselData = ''
      for (const item in myRefs.relatedVesselDetails) {
        vesselData = myRefs.relatedVesselDetails[item].getData()
        vesselData.vessel_type = 'vessel'
        data.push(vesselData)
      }

      for (const item in myRefs.relatedAeroplaneDetails) {
        vesselData = myRefs.relatedAeroplaneDetails[item].getData()
        vesselData.vessel_type = 'aeroplane'
        data.push(vesselData)
      }

      return data
    },
    setData: function (data) {
      var vessels = []
      var aeroplanes = []

      for (const index in data) {
        if (data[index].vessel_type === 'aeroplane') {
          aeroplanes.push(data[index])
        }

        if (data[index].vessel_type === 'vessel') {
          vessels.push(data[index])
        }
      }

      this.vessels = []
      var refs = this.$refs

      for (const index in aeroplanes) {
        var newAeroplane = {
          type: aeroplanes[index].vessel_type
        }
        delete aeroplanes[index].vessel_type
        this.vessels.push(newAeroplane)
        this.$nextTick(() => refs.relatedAeroplaneDetails[index].setData(aeroplanes[index]))
      }

      for (const index in vessels) {
        var newVessel = {
          type: vessels[index].vessel_type
        }
        delete vessels[index].vessel_type
        this.vessels.push(newVessel)
        this.$nextTick(() => refs.relatedVesselDetails[index].setData(vessels[index]))
      }
    }
  }
}
</script>
